// The time to wait until committing changes during editing.
export const COMMIT_CHANGES_TIME_SEC = 1;

// Formatting
export const MAX_LIST_DEPTH = 4;

// Max summary heading length
export const MAX_HEADING_SUMMARY_LENGTH = 32;
